import { frontendURL } from '../../../../helper/URLHelper';

// The Chatwoot Enterprise "Audit Logs" page read the same `audits` table as
// Teletel's own audit trail, so the owner removed it (2026-09-19). Its page
// component stays in the tree unused; the old address lands on the Teletel
// page so saved links keep working.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs'),
      redirect: to => ({ name: 'teletel_audit_trail', params: to.params }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs/list'),
      name: 'auditlogs_list',
      redirect: to => ({ name: 'teletel_audit_trail', params: to.params }),
    },
  ],
};
